angular.module('inscriptions_forms')

    .controller('InscriptionsTemplatesModalCtrl', ['event_id', '$scope', '$uibModal', '$uibModalInstance', '$http', 'Restangular', 'LoginService', '$filter', '$timeout', '$rootScope',
        function (event_id, $scope, $uibModal, $uibModalInstance, $http, Restangular, LoginService, $filter, $timeout, $rootScope) {

        $scope.search = { inscription_id: null };

            Restangular.all('InscriptionsForms').getList({ event_id:0, is_template: true}).then(function (inscriptions) {
            $scope.selectInscriptions = [];
            angular.forEach(inscriptions, function (inscription) {
                $scope.selectInscriptions.push({ id: inscription.id, fullname: inscription.event_name});
            })
        });

        $scope.loadTemplateOnEvent = function () {
            
            if ($scope.search.inscription_id == null) {
                toastr.error($filter('translate')('general.no_element_selected'));
                return;
            }

            Restangular.all('InscriptionsForms').customPOST({}, "DuplicateInscriptionFormToEvent", { id: $scope.search.inscription_id, event_id: event_id }).then(function (result) {
                $uibModalInstance.close(result);
            }, function (error) {
                        let errorMessage = "Error desconocido";
                        if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                        toastr.error(errorMessage);
            });
            
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
;